import React from 'react';
import {
    Modal,
    Box,
    Grid,
    TextField,
    Button,
} from '@mui/material';

import { IMAGE_URL } from '../constants/Constants';


const AddPlayerModal = ({ open, handleClose, handleSubmit }) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box sx={{
                padding: '16px',
                backgroundColor: '#f5f5f5',
                borderRadius: '8px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                maxWidth: '500px',
                width: '70%',
            }}>
                <Box display="flex" justifyContent="center" alignItems="center" sx={{ width: '60x', p: 1 }}>
                    <img
                        loading="lazy"
                        src={`${IMAGE_URL}headers/AddPlayer.png`}
                        style={{ width: '90%' }}
                        alt="Add Player"
                    />
                </Box>
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ p: 1 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="firstName"
                                label="First Name"
                                name="firstName"
                                autoFocus
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="lastName"
                                label="Last Name"
                                type="text"
                                id="lastName"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button type="submit" variant="contained" fullWidth>
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Modal>
    );
};

export default AddPlayerModal;
